"use strict"

const axiosRetry = require("axios-retry")
const axios = require(`axios`)

axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

const httpExceptionHandler = require(`./httpExceptionHandler`)

const fetchStatamicResource = async apiUrl => {
  try {
    const response = await axios.get(apiUrl)
    return response.data.data
  } catch (e) {
    httpExceptionHandler(e)
  }
}

module.exports = fetchStatamicResource
